import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  id: "list-card",
  class: "__samplingpoints"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-check fas" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_table, { data: _ctx.listSamplingPoints }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: _ctx.$t('label.name'),
                width: "180"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "description",
                label: _ctx.$t('label.description')
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "station",
                label: _ctx.$t('label.station'),
                width: "280"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_select, {
                    modelValue: scope.row.station,
                    "onUpdate:modelValue": ($event: any) => ((scope.row.station) = $event),
                    "value-key": "id",
                    filterable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: _ctx.$t('label.noStation'),
                        value: null
                      }, null, 8, ["label"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stations, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                fixed: "right",
                label: _ctx.$t('label.save')
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    onClick: ($event: any) => (_ctx.saveChanges(scope.row)),
                    title: _ctx.$t('btn.save'),
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 2
                  }, 1032, ["onClick", "title"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _: 1
      })
    ])
  ]))
}